import {combineReducers} from 'redux'
import {SET_NODE_META_DATA,
SET_NODE_PATH_TO_DATA,
SET_NODE_SCORE_FUNCTION,
SET_NODE_DEF_WIGHT,
SET_NODE_DATA,
LOADED_OPTIONS} from './actions'
import {SET_CHOSEN_OPTION_CATEGORY,
          SET_OPTION_META_DATA,CHECK_UPDATE,
          SET_OPTIONS,RESORT_OPTIONS,CALCULTE_SCORE,} from './actions'
import {SET_TREE_META_DATA, SET_TREE_DATA, UPDATE_USER, SET_PICKED_TREE_ID, SET_NODES_DATA,
   SET_TREE_BUILD_DATA, SET_PICKED_NODE_ID,
   USER_LOGGING, AUTH_ERROR,USER_LOADED,USER_LOADING,
 LOG_IN_FULFILLED, REGISTER_SUCCESS, LOG_IN_REJECTED, LOGOUT_SUCCESS, REGISTER_FAIL,
SET_NODE_WIGHT, ADD_OPTION_QUERY_PARAM,
ERROR_LOADING_OPTIONS,SET_OPTIONS_DISPLAY,
SET_CONTROL_OPTIONS_DISPLAY, SET_PAGINTATION_DATA, DELETE_OPTION_QUERY_PARAM, SET_TREE_CONTEXT,SET_PREFERNCE_ITEM,SET_NODE_CONTEXT, SET_NODE_FUNCTION_DATA} from './actions'

import {ADD_PROCESS, SET_PROCESS_STATE, DELETE_PROCESS} from './actions'
import {ADD_ERROR, SET_ERRORS, CLEAN_ERRORS} from './actions'
import {ADD_OPTION_COMPARE, REMOVE_OPTION_COMPARE} from './actions'
import {SET_EXTENDED_SCORES} from './actions'
import {SET_CUR_DISPLAY} from './actions'
import {ADD_FILTER, DELETE_FILTER} from './actions'
import {SET_CAN_SHOW_AMAZON_LINKS} from './actions'
import {ADD_BREAD_CRUMB} from './actions'
import {INCREASE_COUNTER, DECREASE_COUNTER} from './actions'

import {setChosenOptionCategory} from './actions'
import {dbGetOptionMetaData} from '../dbApi/DbApi.js'
import {checkAmazonConection} from '../dbApi/DbApi.js'

const initialUserState = {
  key: localStorage.getItem("key"),
  isAuthenticated: null,
  isLoading: false,
  user: localStorage.getItem("user"),
}

const userReducer = (state = initialUserState, action) => {
  switch (action.type) {
    case USER_LOADING:
      return {
              ...state,
              isLoading: true,
            };
      break;
    case USER_LOADED:
      return {
        ...state,
        isAuthenticated: true,
        isLoading: false,
        user: action.payload,
      };
      break;
    /* sucsses cases */
    case LOG_IN_FULFILLED:
    case REGISTER_SUCCESS:
      console.log("REGISTER_SUCCESS");
      localStorage.setItem('key', action.payload.key);
      localStorage.setItem('user', action.payload.user);
      console.log({
        ...state,
        ...action.payload,
        isAuthenticated: true,
        isLoading: false,
      });
      return {
        ...state,
        ...action.payload,
        isAuthenticated: true,
        isLoading: false,
      };

    /* error cases */
    case AUTH_ERROR:
    case LOG_IN_REJECTED:
    case LOGOUT_SUCCESS:
    case REGISTER_FAIL:
      console.log("logout was succsful");
      localStorage.removeItem('key');
      localStorage.removeItem('user');
      return {
          ...state,
          key: null,
          user: null,
          isAuthenticated: false,
          isLoading: false,
      };
      break;
    default:
      return state
  }
}


const pickedNodeIdReducer = ( state=null, action) => {
  switch (action.type) {
    case SET_PICKED_NODE_ID:
      console.log(`setting node id  ${action.payload}`);
      return action.payload
      break;
    default:
      return state
  }
}

const pickedTreeIdReducer = ( state=null, action) => {
  switch (action.type) {
    case SET_PICKED_TREE_ID:
      return action.payload
      break;
    default:
      return state
  }
}


const metaDataReducer = (state={title:"", description:""}, action) => {
  switch (action.type) {
    case SET_TREE_META_DATA:
      return action.payload;
      break;
    default:
      return state
  }
}

const chosenOptionsCategoryReducer = (state=null, action) => {
  switch (action.type){
      case SET_CHOSEN_OPTION_CATEGORY:
        return action.payload;
        break;
      default:
        return state;
  }
}

const optionMetaDataReducer = (state={fields:[]}, action) => {
  switch (action.type){
      case SET_OPTION_META_DATA:
        return action.payload;
        break;
      default:
        return state;
  }
}

const optionsReducer = (state=[], action) => {
  switch (action.type){
      case LOADED_OPTIONS:
        return action.payload;
        break;
      case ERROR_LOADING_OPTIONS:
        return [];
        break;
      case RESORT_OPTIONS:
        const tree = action.payload;
        console.log("before sort:");
        console.log(state);
        let sorted =  state.sort((a, b) => (tree.getOptionScore(b) - tree.getOptionScore(a)));
        console.log("after sort:");
        console.log(state);
        console.log(sorted);
        return state;
        break;
      default:
        return state;
  }
}

const optionsCompareReducer = (state={}, action) => {
  let name;
  switch (action.type){
      case ADD_OPTION_COMPARE:
        name = action.payload.title;
        if(Object.values(state).length < 4){
          state[name] = action.payload;
        }
        return {...state}
        break;
      case REMOVE_OPTION_COMPARE:
        name = action.payload.title;
        if( name in state){
          delete state[name];
        }
        return {...state};
        break;
      default:
        return state;
  }
}


const preferenceTreeReducer =  (state = {id: null,
                                          description: null,
                                          title: null,
                                          owner: null,
                                          root_node:null}
                                          , action) => {
    console.log("preference tree before:");
    console.log(state);
    console.log(action);
    switch (action.type) {
      case SET_TREE_DATA:
        console.log("preference tree after:");
        console.log(state);
        return action.payload;
        break;
      default:
        return state;
    }
}

const nodesExtreDataReducer =  (state = {}, action) => {
  switch (action.type) {
    case SET_NODE_DATA:
      return { ...state,
                [action.payload.id]:action.payload.data
              };
      break;
    case SET_NODE_WIGHT:
      return { ...state,
                [action.payload.id]: {
                  ...state[action.payload.id],
                  wight:action.payload.wight
                }
              };
      case SET_TREE_CONTEXT:
      console.trace();
        return action.payload;
      case SET_NODE_CONTEXT:
          return { ...state,
                    [action.payload.id]: {
                      ...action.payload.nodeContext
                    }
                  };
      case SET_NODE_FUNCTION_DATA:
          console.log(action);
          return { ...state,
                    [action.payload.id]: {
                      ...state[action.payload.id],
                      functionData:action.payload.functionData
                    }
                  };
    default:
      return state;
  }
    return state;
}

const userNodesDateReducer =  (state = {}, action) => {
  switch (action.type) {
    case SET_NODE_DATA:
      return { ...state,
                [action.payload.id]:action.payload.data
              };
      break;
    case SET_NODE_WIGHT:
      return { ...state,
                [action.payload.id]: {
                  ...state[action.payload.id],
                  wight:action.payload.wight
                }
              };
      case SET_NODE_CONTEXT:
          return { ...state,
                    [action.payload.id]: {
                      ...action.payload.nodeContext
                    }
                  };
      case SET_NODE_FUNCTION_DATA:
          console.log(action);
          return { ...state,
                    [action.payload.id]: {
                      ...state[action.payload.id],
                      functionData:action.payload.functionData
                    }
                  };
    default:
      return state;
  }
    return state;
}


const reloadUrl = (query) => {
  let url = window.location.href.split("?")[0] + "?";
  console.log(`url: ${url}`);
  for (const [key, value] of Object.entries(query)) {
      url = url + key + "=" + value + "&";
  }
  window.location.href = url;
}

const optionQueryParamsReducer = (state = {}, action) => {
  switch (action.type) {
    case ADD_OPTION_QUERY_PARAM:
      console.log("reducer to set query param");
      console.log(action);
      const newState = { ...state,
              [action.payload.name]: action.payload.value
              }
      reloadUrl(newState)
      return newState;
      break;
    case DELETE_OPTION_QUERY_PARAM:
      delete state[action.payload];
      reloadUrl(state)
      return {...state}
    default:
      return state;
  }
}

const optionFiltersReducer =  (state = {}, action) => {
  switch (action.type) {
    case ADD_FILTER:
      const newState = { ...state,
              [action.payload.name]: action.payload.value
              }
      return newState;
      break;
    case DELETE_FILTER:
      delete state[action.payload];
      return {...state}
    default:
      return state;
  }
}

const optionsDisplayReducer = (state = "list", action) => { // TODO: raw string
  switch (action.type) {
    case SET_OPTIONS_DISPLAY:
      return action.payload;
      break;
    default:
      return state;
  }
  return state;
}

const controlOptionsDisplayReducer = (state = "PREFERNCES", action) => {
  switch (action.type) {
    case SET_CONTROL_OPTIONS_DISPLAY:
      return action.payload;
      break;
    default:
      return state;
  }
  return state;
}

const pagintationDataReducer = (state={}, action) => {
  switch (action.type) {
    case SET_PAGINTATION_DATA:
      return action.payload;
      break;
    default:
      return state;
  }
  return state;
}


const preferenceItemReducer = (state={}, action) => {
  switch (action.type) {
    case SET_PREFERNCE_ITEM:
      return action.payload;
      break;
    default:
      return state;
  }
  return state;
}

const processReducer = (state={}, action) => {
  switch (action.type) {
    case ADD_PROCESS:
      return {
        ...state,
        [action.payload.id]:action.payload.status,
      };
      break;
      case SET_PROCESS_STATE:
      return {
        ...state,
        [action.payload.id]:action.payload.status,
      };
      break;
    case DELETE_PROCESS:

      break;
    default:
      return state;
  }
  return state;
}

const errorsReducer = (state={}, action) => {
  switch (action.type) {
    case ADD_ERROR:
      return {
        ...state,
        [action.payload.id]:action.payload.error,
      };
      break;
      case SET_ERRORS:
        return {
          ...state,
          [action.payload.id]:action.payload.errors,
        };
        break;
    case CLEAN_ERRORS:

      break;
    default:
      return state;
  }
  return state;
}

const extendedScoresReducer = (state={}, action) => {
  switch (action.type) {
    case SET_EXTENDED_SCORES:
      return action.payload;
      break;
    default:
      return state;
  }
}

const curScreenReducer = (state="PREFERNCES", action) => {
  switch (action.type) {
    case SET_OPTIONS_DISPLAY:
      return action.payload;
      break;
    case SET_CONTROL_OPTIONS_DISPLAY:
      return action.payload;
      break;
    case SET_CUR_DISPLAY:
      return action.payload;
      break;
    default:
      return state;
  }
}

const canShowAmazonLinksReducer = (state=false, action) => {
  switch (action.type) {
    case SET_CAN_SHOW_AMAZON_LINKS:
      console.log(`amazon conection state: ${action.payload}`);
      return action.payload;
      break;
    default:
      return state;
  }
}

const breadcrumbdsReducer = (state=[], action) => {
  switch (action.type) {
    case ADD_BREAD_CRUMB:
      return state.push(action.payload);
      break;
    default:
      return state;
  }
}

const counterReducer = (state=0, action) => {
  switch (action.type) {
    case INCREASE_COUNTER:
      return state + 1;
      break;
    case DECREASE_COUNTER:
      return state - 1;
      break;
    default:
      return state;
  }
}

const reducer = combineReducers({
  counter: counterReducer,
  nodesData: nodesExtreDataReducer,
  userNodesDate: userNodesDateReducer,
  preferenceTree: preferenceTreeReducer,
  metaData: metaDataReducer,
  pickedNodeId: pickedNodeIdReducer,
  pikedTreeID: pickedTreeIdReducer,
  auth: userReducer,
  optionQueryParams:optionQueryParamsReducer,
  optionFilters:optionFiltersReducer,
  options: combineReducers({
          chosenOptionsCategory: chosenOptionsCategoryReducer,
          optionMetaData: optionMetaDataReducer,
          optionsChosen: optionsReducer,
          optionsCompare: optionsCompareReducer,
          extendedScores: extendedScoresReducer,
        }),
  displayState:combineReducers({
    optionsDisplay: optionsDisplayReducer,
    controlOptionsDisplay: controlOptionsDisplayReducer,
  }),
  pagintationData:pagintationDataReducer,
  preferenceItem: preferenceItemReducer,
  processManager:combineReducers({
    processes:processReducer,
    errors: errorsReducer}),
  curScreen: curScreenReducer,
  breadcrumbds: breadcrumbdsReducer,
  canShowAmazonLinks:canShowAmazonLinksReducer,
})

export default reducer
